// InFlowLoanDetails.jsx

import React, { useEffect, useState } from "react";
import { Grid, withStyles } from "@material-ui/core";
import CustomeTextField from "components/UpdateUi/CustomeTextField";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomeSelectNew from "components/UpdateUi/CustomeSelect.js";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { useSelector } from "react-redux";
import { formatAmount } from "utils/Utils";
import { numericValueRegex } from "utils/Utils";
import IconButton from "@material-ui/core/IconButton";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import { creditAssessmentFields } from "assets/properties/properties";
import { isValidValue } from "utils/Utils";
import { removeSpecialCharFileName } from "utils/Utils";
import FileUploadDocument from "components/FileUpload/FileUploadDocument";
import brandTheme from "brandTheme/Theme";
const styles = () => ({
  mainContainer: {
    width: "100%",
    margin: "20px auto",
    boxShadow: "0 10px 15px rgba(0,0,0,0.04)",
    border: "1px solid rgba(0,0,0,0.04)",
    padding: "10px 25px",
  },
  uploadContainer: {
    '& div[role="button"]': {
      height: "150px !important",
      margin: "0px 10px !important",
    },
  },
});
const InFlowLoanDetails = ({
  editable=false,
  handleBlurAnnualIncome,
  classes,
  annualIncome = 0,
  setAnnualIncome,
  totalInFlowIncome = 0,
  setAdditionalIncomeList,
  additionalIncomeList = [],
  setCallInProgress,
  foirValueAmount,
}) => {
  const [additionalSourceList, setAdditionalSourceList] = useState([]);
  const [additionalDocumentList, setAdditionalDocumentList] = useState([]);
  const { authToken } = useSelector((state) => state.login.authData);

    const totalInflow = () =>{
      return (
        <Grid item xs={12} md={3}  style={{display:"flex", flexDirection:'column', textAlign:'right'}}>
        <span style={{fontSize:'13px', fontWeight:700}}>Monthly Total Inflow</span>
        <span style={{fontSize:'22px', fontWeight:700}}>{formatAmount(totalInFlowIncome)}</span>
        </Grid>
      )
    }
  const getMasterCategoryList = async () => {
    const result = await apiHandler({
      url: endpoint.MASTER_DATA_BY_CATEGORY_CODE,
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      console.log();
    } else {
      const sourceData = Object.values(result?.data || {}).find(
        (value) => Array.isArray(value)
      );
      const data = (sourceData || []).map((item) => ({
        code: item,
        name: item,
      }));
      setAdditionalSourceList(data);
      getDocumentList();
    }
  };
  useEffect(() => {
    getMasterCategoryList();
  }, []);
  const getDocumentList = async () => {
    const result = await apiHandler({
      url: endpoint.MASTER_DATA_DOCUMENT_LIST,
      authToken: authToken,
    });
    if (result?.data?.error_code) {
      console.log();
    } else {
      const sourceData = Object.values(result?.data || {}).find(
        (value) => Array.isArray(value)
      );
      const data = (sourceData || []).map((item) => ({
        code: item,
        name: item,
      }));
      setAdditionalDocumentList(data);
    }
  };
  const handleAddRow = () => {
    setAdditionalIncomeList([
      ...additionalIncomeList,
      {
        additionalSource: "",
        additionalIncome: "",
        address:"",
        attachment:"",
      },
    ]);
  };

  const handleDeleteRow = (index) => {
    const updated = [...additionalIncomeList];
    updated.splice(index, 1);
    setAdditionalIncomeList(updated);
  };

  const handleChange = (index, field, value) => {
    const updated = [...additionalIncomeList];
    updated[index][field] = value;
    setAdditionalIncomeList(updated);
  };

  const UploadFile = async (file, index) => {
   const formData = new FormData();
   const fileName = removeSpecialCharFileName(file.name);
   formData.append("file", file, fileName);
     setCallInProgress(true)
   const path = await apiHandler({
     url: endpoint.FILE_UPLOAD,
     method: "POST",
     authToken: authToken,
     data: formData,
   });
     setCallInProgress(false)
   const uploadedPath = path.data?.name;
   handleChange(index, "attachment", uploadedPath)
  };
  return (
    <Grid container spacing={2} className={classes.mainContainer}>
      <Grid item xs={12}>
        <SubHeader
          label={creditAssessmentFields.inflowLabelLoanDetails}
          message={totalInflow()}
          withRightText
        />
      </Grid>
         <Grid item xs={12} md={3} className={classes.fieldContaienr}>
          <CustomeTextField
            label="Max Obligation (as per FOIR)"
            value={formatAmount(foirValueAmount, false)}
            disabled
          />
        </Grid>
         <Grid item xs={12} md={3} className={classes.fieldContaienr}>
        <CustomeTextField
          label="Monthly Income"
          value={annualIncome || ""}
          setState={(value) => {
            if (numericValueRegex(value)) {
              setAnnualIncome(value);
            }
          }}
          disabled={!editable}
          setBlur={handleBlurAnnualIncome}
        />
      </Grid>
       <Grid item xs={12} md={6} />
          {additionalIncomeList.map((item, index) => (
            <React.Fragment key={index}>
              <Grid item xs={12} md={3} className={classes.fieldContaienr}>
                <CustomeSelectNew
                  label="Income Sources*"
                  id={`additional_source_${index}`}
                  value={item.additionalSource}
                  setState={(value) =>
                    handleChange(index, "additionalSource", value)
                  }
                  data={additionalSourceList}
                  disabled={!editable}
                  type="type"
                />
              </Grid>

              <Grid item xs={12} md={3} className={classes.fieldContaienr}>
                <CustomeTextField
                  label="Monthly Income"
                  value={item.additionalIncome}
                  setState={(value) => {
                    if (numericValueRegex(value)) {
                      handleChange(index, "additionalIncome", value);
                    }
                  }}
                  disabled={!editable}
                />
              </Grid>
                <Grid item xs={12} md={3} className={classes.fieldContaienr}>
                  <CustomeSelectNew
                    label="Document Type*"
                    id={`document_type_${index}`}
                    value={item?.attachmentType}
                    setState={(value) =>
                      handleChange(index, "attachmentType", value)
                    }
                    data={additionalDocumentList}
                    disabled={!editable}
                    type="type"
                  />
                </Grid>
                <Grid
                    item
                    xs={12}
                    sm={12}
                    md={2}
                    className={`${classes.fieldContaienr} ${classes.uploadContainer}`}
                    // style={{display:'flex'}}
                    >
                    <FileUploadDocument
                      addButtonProps={{ color: brandTheme.buttonColor }}
                      changeButtonProps={{ color: brandTheme.buttonColor }}
                      removeButtonProps={{ color: brandTheme.button2Color }}
                      supportedMimeType={[
                        "image/jpeg",
                        "image/bmp",
                        "image/png",
                        "image/tiff",
                        "application/pdf",
                      ]}
                      sendFile={(file) => UploadFile(file, index)}
                      removeFile={() => handleChange(index, "attachment", "")}
                      previewImage={item?.attachment}
                      // ref={occupationRef}
                      removeButton={!editable}
                      name={!editable}
                      editable={editable}
                    />
                    </Grid>
              <Grid
                item
                xs={12}
                md={1}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {index === additionalIncomeList.length - 1 && item.additionalSource && item.additionalIncome && editable && (
                  <IconButton onClick={handleAddRow}>
                    <AddCircleOutlineIcon color="primary" />
                  </IconButton>
                )}

                {additionalIncomeList.length > 1 && editable && (
                  <IconButton onClick={() => handleDeleteRow(index)}>
                    <DeleteOutlineIcon color="secondary" />
                  </IconButton>
                )}
              </Grid>

              <Grid item xs={12} />
            </React.Fragment>
          ))}
    </Grid>
  );
};

export default withStyles(styles)(InFlowLoanDetails);
